<template>
  <div class="prompt">
    <div class="prompt-label">{{ label }}</div>
    <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
      <div style="height: 100%;">
        <div v-if="MissingValues.length > 0">
          <p style="font-size: 13px; font-weight: bold;">Missing value(s)</p>
          <div>
            <li style="font-size: 12px; color: red; list-style-type: none;" v-for="item, index in MissingValues"
              :key="index">{{ item.name }}
            </li>
          </div>
        </div>
        <div v-if="GreaterZero.length > 0">
          <p style="font-size: 14px; font-weight: bold;">Value(s) needs to be greater then zero:</p>
          <div>
            <li style="font-size: 12px; color: red; list-style-type: none;" v-for="item, index in GreaterZero"
              :key="index">{{ item.name }}
            </li>
          </div>
        </div>
      </div>
      <div class="button-holder">
        <div class="cancel-button" @click="handleCancel">Cancel</div>
      </div>
    </div>
  </div>
</template>

<script>
import { usePipeStore } from '@/store/PipeStore';


export default {
  name: 'ModalWarning',
  props: [
    'errors',
    'label',
  ],
  computed: {
    Errors () {
      return this.$props.errors;
    },
    MissingValues () {
      return this.Errors.filter((item) => item.error === 'missing_value');
    },
    GreaterZero () {
      return this.Errors.filter((item) => item.error === 'greater_then_zero');
    }
  },
  methods: {
    handleCancel () {
      usePipeStore().modalError = false;
    }
  }
};
</script>

<style scoped>
.prompt {
  position: relative;
  width: 250px;
  height: 275px;
  padding: 10px 20px;
  background-color: white;
border: 3px solid rgb(241, 241, 241);
}

.button-holder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 5px;
  /* padding-top: 20px; */
}

.button {
  margin: 5px;
  padding: 10px 25px;
  color: white;
  font-weight: 700;
  font-size: .9em;
  text-transform: uppercase;
  cursor: pointer;
  background-color: var(--nelson-green);
}

.prompt-label {
  text-align: center;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.prompt-description {
  padding-bottom: 10px;
  font-size: .95em;
}

.cancel-button {
  background-color: #F6F6F6;
cursor: pointer;
  color: black;
  height: 35px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
  font-weight: 500;
}
</style>